import { AdminDataTableSection, AdminPage, AdminPageHeader } from '../../common/components'
import { Text } from '../../common/designs'

const SuperuserGuide = () => {
  return (
    <AdminPage width='full'>
      <AdminPageHeader
        title='Superuser Access Guide'
        description='Superuser permissions are intentionally limited and controlled to protect customer data and platform integrity.'
      />

      <AdminDataTableSection>
        <div className='space-y-5'>
          <div className='space-y-2'>
            <Text size='m' weight={700}>
              How superuser access is assigned
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              Superuser status is assigned only through the database. There is no self-service or
              alternative in-product method to grant this status.
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              Access grants are handled only by the PI Development Team and CloudOps.
            </Text>
          </div>

          <div className='space-y-2'>
            <Text size='m' weight={700}>
              Scope of superuser privileges
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              Superusers can access every instance in the environment and switch between them with
              unrestricted access.
            </Text>
          </div>

          <div className='space-y-2'>
            <Text size='m' weight={700}>
              Usage policy
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              No customer should ever have superuser access. Even internally, this permission is
              strictly rationed and granted only when necessary.
            </Text>
          </div>

          <div className='space-y-2'>
            <Text size='m' weight={700}>
              Technical enforcement
            </Text>
            <Text size='s' color='gray' className='leading-relaxed'>
              Relevant endpoints are guarded and reject usage when required permissions are missing.
            </Text>
          </div>
        </div>
      </AdminDataTableSection>
    </AdminPage>
  )
}

export default SuperuserGuide

